"use client";

import styles from "./styles/ContentItemPage.module.scss";
import ApiClient from "../../backends/ApiClient";
import SafeRouter from "../../components/utilities/SafeRouter";
import { getPaths } from "../../utils/SchoolBlocksUtilities";
import { withoutLocaleInURI } from "../../internationalization/i18nURI";
import AccordionItemModalContent from "../../components/modals/AccordionModal/AccordionItemModalContent";
import { ReactiveAccordionItem } from "../../components/schoolfeed/ReactiveAccordionItem";
import { useStores } from "../../stores/useStores";
import { useRef } from "react";

export default function AccordionItemPage(props: { item: IAccordionItem }) {
  const { interfaceStore } = useStores();

  const reactiveItem = useRef(new ReactiveAccordionItem(props.item));

  const pathSegments: string[] = getPaths(
    withoutLocaleInURI(interfaceStore.currentFullUrl),
  );
  const orgId = pathSegments[pathSegments.length - 3];

  const terrace = (props as any)?.item?.terrace;

  const handleSave = async (
    item: IAccordionItemEditing,
  ): Promise<ReactiveAccordionItem> => {
    const client = await ApiClient();
    const updatedData = await (client.PATCH(
      "/organizations/{organization_pk}/terraces/{terrace_pk}/accordion_items/{id}/",
      {
        params: {
          path: {
            organization_pk: terrace.organization_id,
            terrace_pk: terrace.id,
            id: item.id as number,
          },
          query: { expand: "content_html" },
        },
        // the spec's AccordionItemRequest requires `path`, but this is a
        // partial update and the backend has always accepted this subset (SBSB-2912)
        body: {
          title: item.title,
          description: item.description,
          content_html: item.content_html,
          modal_enabled: item.modal_enabled,
        } as never,
      },
    ) as any);
    reactiveItem.current!.update(updatedData);
    return reactiveItem.current!;
  };

  return (
    <div className={styles.container}>
      {props.item ? (
        <AccordionItemModalContent
          closeFunction={async () => await SafeRouter.push(`/pages/${orgId}`)}
          itemObj={reactiveItem.current}
          handleSave={handleSave}
          index={0}
          blockObj={terrace}
        />
      ) : (
        <div className={styles.loadingIndicator}>Accordion Item not found.</div>
      )}
    </div>
  );
}
